<section class="overflow-x-auto p-6 bg-white rounded-xl shadow">
  <div class="title text-lg font-semibold mb-4">
    {{ 'applications.title' | translate }}
    <span class="ml-2 bg-gray-200 text-gray-700 px-4 py-1 rounded-full text-sm">
      {{ applications.length }}
    </span>
  </div>

  <table mat-table [dataSource]="applications" class="mat-elevation-z1 w-full">

    <!-- Candidate Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> {{ 'applications.candidates' | translate }}</th>
      <td mat-cell *matCellDef="let app">
        <div class="row flex items-center gap-2">
          <img [src]="app.applicantProfileImageUrl" class="profile-img w-8 h-8 rounded-full"/>
          <span class="name">{{ app.applicantName }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Country Column -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef> {{ 'applications.country' | translate }}</th>
      <td mat-cell *matCellDef="let app">
        <div class="flex items-center gap-2">
          <span class="flag-emoji">{{ getFlagEmoji(app.location) }}</span>
          <span class="country text-gray-700">{{ app.location }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Language Level Column -->
    <ng-container matColumnDef="language">
      <th mat-header-cell *matHeaderCellDef> {{ 'applications.languageLevel' | translate }}</th>
      <td mat-cell *matCellDef="let app">
        <div class="flex items-center gap-2">
          <span class="language bg-gray-100 text-gray-700 py-1 px-2 rounded text-xs">
            <span class="flag-emoji">{{ getFlagEmoji(app.location) }}</span>
            {{ 'applications.fluentInEnglish' | translate }}
          </span>
        </div>
      </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> {{ 'applications.appliedDate' | translate }}</th>
      <td mat-cell *matCellDef="let app" class="text-gray-600 date">
        {{ app.appliedAt | date: 'EEE, dd MMM yyyy – h:mma' }}
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> {{ 'applications.processStatus' | translate }}</th>
      <td mat-cell *matCellDef="let app">
        <span class="status-badge" [ngClass]="{
          'status-application': app.status === 'PENDING',
          'status-shortlisted': app.status === 'SHORTLISTED',
          'status-interview': app.status === 'INVITED_TO_INTERVIEW',
          'status-under-review': app.status === 'INTERVIEWED',
          'status-offered': app.status === 'OFFERED',
          'status-hired': app.status === 'ACCEPTED',
          'status-rejected': app.status === 'REJECTED'
        }">
          {{ ('applications.status.' + app.status) | translate }}
        </span>
      </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> {{ 'applications.action' | translate }}</th>
      <td mat-cell *matCellDef="let app">
        <app-application-actions
          (click)="$event.stopPropagation()"
          [app]="app"
          [userId]="app.userId"
          [isMobile]="false"
          role="company"
          variant="menu">
        </app-application-actions>



      </td>
    </ng-container>


    <!-- Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row
        *matRowDef="let app; columns: displayedColumns"
        (click)="navigateToApplication(app)"
        style="cursor: pointer;">
    </tr>
  </table>
</section>
